module.exports = __webpack_public_path__ + "img/sintesis.f3c9d2ed.jpg";